/* eslint-disable no-case-declarations */

import {
  LOADING_CAMPAIGNS,
  LOADING_CAMPAIGNS_SUCCESS,
  LOADING_CAMPAIGNS_ERROR,

  LOADING_CAMPAIGN_ADVERTISES,
  LOADING_CAMPAIGN_ADVERTISES_SUCCESS,
  LOADING_CAMPAIGN_ADVERTISES_ERROR,

  ADDING_CAMPAIGN,
  ADDING_CAMPAIGN_SUCCESS,
  ADDING_CAMPAIGN_ERROR,

  UPDATING_CAMPAIGN,
  UPDATING_CAMPAIGN_SUCCESS,
  UPDATING_CAMPAIGN_ERROR,

  DELETING_CAMPAIGN,
  DELETING_CAMPAIGN_SUCCESS,
  DELETING_CAMPAIGN_ERROR,

  LOADING_CAMPAIGN_INFO,
  LOADING_CAMPAIGN_INFO_SUCCESS,
  LOADING_CAMPAIGN_INFO_ERROR,

  FINDING_CAMPAIGNS,
  FINDING_CAMPAIGNS_SUCCESS,
  FINDING_CAMPAIGNS_ERROR,
} from '../actions/campaigns';

const initialState = {
  advertiseList: [],
  campaignList: [],
  campaign_total: 0,
  campaignInfo: {},
  loading: false,
  find_loading: false,
};
  
const CampaignsReducer = (state = initialState, action) => {
    switch (action.type) {
      case LOADING_CAMPAIGNS:
        return { ...state, loading: true };
  
      case LOADING_CAMPAIGNS_SUCCESS:
        return {
          ...state,
          loading: false,
          campaignList: action.payload,
        };

      case LOADING_CAMPAIGN_ADVERTISES:
        return { ...state, loading: true };
  
      case LOADING_CAMPAIGN_ADVERTISES_SUCCESS:
        //console.log(action.payload);
        return {
          ...state,
          loading: false,
          advertiseList: action.payload,
        };

      case ADDING_CAMPAIGN:
        return { ...state, loading: true };
  
      case ADDING_CAMPAIGN_SUCCESS:
        return {
          ...state,
          loading: false,
          campaignList: [...state.campaignList, action.payload],
        };

      case UPDATING_CAMPAIGN:
        return { ...state, loading: true };
  
      case UPDATING_CAMPAIGN_SUCCESS:
        const campaign = action.payload;
        //console.log(state.campaignList);
        const newCampaigns = state.campaignList.map((obj) => {
          return campaign.id === obj.id ? campaign : obj;
        });
        //console.log(newCampaigns);
        return {
          ...state,
          loading: false,
          campaignList: [...newCampaigns]
        };

      case DELETING_CAMPAIGN:
        return { ...state, loading: true };
  
      case DELETING_CAMPAIGN_SUCCESS:
        return {
          ...state,
          loading: false,
          campaignList: [...state.campaignList.filter((obj) => {
            const findObj = action.payload.find(removedCampaign => (removedCampaign.id === obj.id));
            if (findObj === undefined)
              return true;
            return (obj.id !== findObj.id);
          })],
        };

      case LOADING_CAMPAIGN_INFO:
        return { ...state, loading: true };
  
      case LOADING_CAMPAIGN_INFO_SUCCESS:
        //console.log(action.payload);
        return {
          ...state,
          loading: false,
          campaignInfo: action.payload,
        };

      case FINDING_CAMPAIGNS:
        return { ...state, find_loading: true };

      case FINDING_CAMPAIGNS_SUCCESS:
        const {find_total, find_campaigns} = action.payload;
        return {
          ...state,
          find_loading: false,
          campaign_total: find_total,
          campaignList: find_campaigns,
        };

      default:
        return state;
    }
  };
  
  export default CampaignsReducer;
  